const defaults = [
    '#f05c6c',
    '#9fbc34',
    '#85c9c1',
    '#f7d370',
    '#53c0fe',
    '#f9abbb',
    '#0d89d5',
    '#79aff3',
    '#9099cb',
    '#9cb3c3',
    '#ffa66a',
    '#00af86'
];
const letters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
const colorSet = {};
const highLight = ['#ffb53e', '#76c6f5', '#EE55FF', '#BA9EF1', '#93D362'];

let counter = 0;
letters.forEach((letter, idx) => {
    if (idx % defaults.length === 0) counter = 0;
    colorSet[letter] = defaults[counter];
    counter++;
});

counter = 0;
numbers.forEach((number, idx) => {
    if (idx % defaults.length === 0) counter = 0;
    colorSet[number] = defaults[counter];
    counter++;
});

export default {
    defaults,
    mapping: colorSet,
    highLight
};
